<div class="client-profile-section">
  <div class="client-profile-overview-section">
    <img src="assets/user-profile.png" class="client-profile-image" />
    <p class="client-profile-name">
      <span>{{ client_data.first_name }} {{ client_data.last_name }}</span>
    </p>
    <p class="client-profile-id">({{ client_data.client_id }})</p>
    <div class="client-profile-member-section">
      <span class="client-profile-label">Member Since:</span>
      <span class="client-profile-value">{{
        client_data.member_since | date: "dd MMM yyyy"
      }}</span>
    </div>
  </div>
  <div class="client-profile-details-block">
    <div class="client-profile-details-section">
      <p class="client-profile-details-heading">Personal Information</p>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Email ID:</span>
        <span class="client-profile-value">{{ client_data.email }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Date of Birth:</span>
        <span class="client-profile-value">{{
          client_data.birth_date | date: "dd MMM yyyy"
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Gender:</span>
        <span class="client-profile-value">{{ client_data.gender }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Phone Number:</span>
        <span class="client-profile-value">{{
          client_data.telephone_number
        }}</span>
      </div>
    </div>
    <div class="client-profile-details-section">
      <p class="client-profile-details-heading">Contact Information</p>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Address:</span>
        <span class="client-profile-value">{{
          client_data.address_line_1
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">City:</span>
        <span class="client-profile-value">{{ client_data.city }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">State:</span>
        <span class="client-profile-value">{{ client_data.state }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Zip Code:</span>
        <span class="client-profile-value">{{ client_data.zip_code }}</span>
      </div>
    </div>
    <div class="client-profile-details-section">
      <p class="client-profile-details-heading">
        HouseHold & Behavioural Information
      </p>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Household ID:</span>
        <span class="client-profile-value">{{ client_data.household_id }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Is Primary Contact:</span>
        <span class="client-profile-value">
          <span *ngIf="client_data.is_primary_contact">Yes</span>
          <span *ngIf="!client_data.is_primary_contact">No</span>
        </span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Marital Status:</span>
        <span class="client-profile-value">{{
          client_data.maritial_status
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Adults in Household:</span>
        <span class="client-profile-value">{{
          client_data.adults_in_household
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Children in Household:</span>
        <span class="client-profile-value">{{
          client_data.children_in_household
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Household Income Range({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{
          client_data.household_income_in_dollars
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Individual Income Range({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{
          client_data.individual_income_in_dollars
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Real Estate Investor:</span>
        <span class="client-profile-value">
          <span *ngIf="client_data.real_estate_investor">Yes</span>
          <span *ngIf="!client_data.real_estate_investor">No</span>
        </span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Premium Credit Card Holder:</span>
        <span class="client-profile-value">
          <span *ngIf="client_data.premium_credit_card_holder">Yes</span>
          <span *ngIf="!client_data.premium_credit_card_holder">No</span>
        </span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Heavy Transactor:</span>
        <span class="client-profile-value">{{
          client_data.heavy_transactor
        }}</span>
      </div>
    </div>
    <div class="client-profile-details-section">
      <p class="client-profile-details-heading">Other Info</p>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Vehicle Count:</span>
        <span class="client-profile-value">{{
          client_data.vehicle_count
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Vehicle Type:</span>
        <span class="client-profile-value">{{ client_data.vehicle_type }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Property Type:</span>
        <span class="client-profile-value">{{
          client_data.property_type
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Home Equity({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{
          client_data.home_equity_available_for_mortgage_in_dollars
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Loan to Value(%):</span>
        <span class="client-profile-value">{{
          client_data.loan_to_value_in_percentage
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Market Value({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{
          client_data.market_value_of_home_in_dollars
        }}</span>
      </div>

      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Liquid Net Worth({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{ client_data.net_worth }}</span>
      </div>

      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Total Net Worth({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{
          client_data.total_networth
        }}</span>
      </div>

      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Is Business Owner:</span>
        <span class="client-profile-value">
          <span *ngIf="client_data.business_owner">Yes</span>
          <span *ngIf="!client_data.business_owner">No</span>
        </span>
      </div>

      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Managed Money Revenue({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{
          client_data.money_managed_revenue
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Last Periodic Review Date:</span>
        <span class="client-profile-value">{{
          client_data.last_periodic_review_date | date: "dd MMM yyyy"
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Last Contact Date:</span>
        <span class="client-profile-value">{{
          client_data.last_date_of_contact | date: "dd MMM yyyy"
        }}</span>
      </div>

      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Financial Segment:</span>
        <span class="client-profile-value">{{
          client_data.financial_segment
        }}</span>
      </div>

      <!-- <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Confidence Flag:</span>
          <span class="client-profile-value">{{
            client_data.confidence_flag
          }}</span>
        </div> -->
    </div>
    <!-- <div class="client-profile-details-section">
        <p class="client-profile-details-heading">Client Goals</p>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Investment Purpose:</span>
          <span class="client-profile-value">{{client_data.investment_purpose}}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Target Amount({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
          <span class="client-profile-value">{{client_data.target_amount}}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Accomplished Target({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
          <span class="client-profile-value">{{client_data.accomplished_target}}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Investment goal tenure:</span>
          <span class="client-profile-value">{{client_data.investment_goal_tenure}}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Risk Tolerance:</span>
          <span class="client-profile-value">{{client_data.risk_tolerance}}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Other investments({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
          <span class="client-profile-value">{{client_data.other_investment}}</span>
        </div>
      </div> -->
    <div class="client-profile-details-section">
      <p class="client-profile-details-heading">Current Financial Situation</p>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Current Assets({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{
          client_data.current_assests
        }}</span>
      </div>
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Liabilities({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{ client_data.liabilities }}</span>
      </div>
      <!-- <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Income({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
          <span class="client-profile-value">{{
            client_data.individual_income_in_dollars
          }}</span>
        </div> -->
      <div class="each-client-profile-detail-section">
        <span class="client-profile-label">Expenses({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
        <span class="client-profile-value">{{ client_data.expenses }}</span>
      </div>
    </div>
  </div>
</div>
<div
  class="client-products-section"
>
  <div class="client-products-tabs-section">
    <div
      class="each-client-products-tab"
      [ngClass]="{
        'each-client-products-tab-selected': selected_tab == 'Existing Products'
      }"
      (click)="selected_tab = 'Existing Products'"
    >
      <span>Existing Products</span>
    </div>
    <div
      class="each-client-products-tab"
      [ngClass]="{
        'each-client-products-tab-selected': selected_tab == 'Opportunities'
      }"
      (click)="selected_tab = 'Opportunities'"
    >
      <span>Opportunities</span>
    </div>
    <div
      class="each-client-products-tab"
      [ngClass]="{
        'each-client-products-tab-selected': selected_tab == 'Risk'
      }"
      (click)="selected_tab = 'Risk'"
    >
      <span>Risk</span>
    </div>
    <div
      class="each-client-products-tab"
      [ngClass]="{
        'each-client-products-tab-selected': selected_tab == 'Beneficiaries'
      }"
      (click)="selected_tab = 'Beneficiaries'"
    >
      <span>Beneficiaries</span>
    </div>
    <div
      class="each-client-products-tab"
      [ngClass]="{
        'each-client-products-tab-selected': selected_tab == 'Client Goals'
      }"
      (click)="selected_tab = 'Client Goals'"
    >
      <span>Client Goals</span>
    </div>
  </div>
  <div *ngIf="selected_tab == 'Existing Products'">
    <div
      class="each-product-section"
      *ngFor="let product of client_data.existing_products"
    >
      <div class="each-product-heading-section">
        <span>{{ product.product_name }}(ID: {{ product.id }})</span>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Product Type</span>
          <span class="each-product-detail-value">{{
            product.product_type
          }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Financial Institution</span>
          <span class="each-product-detail-value">{{
            product.financial_institution
          }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Policy Number</span>
          <span class="each-product-detail-value">{{
            product.policy_number
          }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">AUM({{APP_CONSTANTS.CURRENCY_SYMBOL}})</span>
          <span class="each-product-detail-value">{{ product.amount }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Tenure(Years)</span>
          <span class="each-product-detail-value">{{ product.age }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Sale Type</span>
          <span class="each-product-detail-value">{{ product.type }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Start Date</span>
          <span
            class="each-product-detail-value"
            *ngIf="product.start_date != '' && product.start_date != null"
            >{{ product.start_date | date: "dd MMM yyyy" }}</span
          >
          <span
            class="each-product-detail-value"
            *ngIf="product.start_date == '' || product.start_date == null"
            >{{ product.start_date }}</span
          >
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Maturity Date</span>
          <span
            class="each-product-detail-value"
            *ngIf="product.maturity_date != '' && product.maturity_date != null"
            >{{ product.maturity_date | date: "dd MMM yyyy" }}</span
          >
          <span
            class="each-product-detail-value"
            *ngIf="product.maturity_date == '' || product.maturity_date == null"
            >{{ product.maturity_date }}</span
          >
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Sold by</span>
          <span class="each-product-detail-value">{{ product.sold_by }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Status</span>
          <span class="each-product-detail-value">{{
            product.client_product_status_name
          }}</span>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="selected_tab == 'Opportunities'">
    <div class="opportunities-section">
      <div class="each-opportunity-section" *ngFor="let opp of client_data.upside_opp" style="width: 100%;">
        <div class="each-opportunity-heading-section">
          <span>{{opp.type}}</span>
          <span class="each-opportunity-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{
            opp.predicted_opportunity
          }}</span>
        </div>
        <div class="each-opportunity-content-section">
          <div
            class="each-opportunity-product-section"
          >
            <!-- <div class="each-opportunity-product-details-section">
              <span class="client-profile-label">Recommended Products:</span>
              <span class="client-profile-value">{{
                opp.recommended_products
              }}</span>
            </div> -->
            <div class="each-opportunity-product-details-section">
              <span class="client-profile-label">Reason:</span>
              <span class="client-profile-value">{{ opp.reason }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="each-opportunity-section" *ngIf="client_data.upside_opp.length == 0" style="width: 100%;">
        <div
          class="each-opportunity-zero-section"

        >
          <span>No Opportunities Found</span>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="selected_tab == 'Risk'">
    <div class="opportunities-section">
      <div class="each-opportunity-section" *ngFor="let risk of client_data.retention_opp" style="width: 100%;">
        <div class="each-opportunity-heading-section">
          <span>{{risk.type}}</span>
        </div>
        <div
          class="each-opportunity-content-section"
        >
          <div
            class="each-opportunity-product-section"
          >
          <div class="each-opportunity-product-details-section">
            <span class="client-profile-label">Actual Loss:</span>
            <span class="client-profile-value">{{
              risk.actual_loss
            }}</span>
          </div>
          <div class="each-opportunity-product-details-section">
            <span class="client-profile-label">Predicted overall loss:</span>
            <span class="client-profile-value">{{
              risk.predicted_overall_loss
            }}</span>
          </div>
            <!-- <div class="each-opportunity-product-details-section">
              <span class="client-profile-label">Recommended Products:</span>
              <span class="client-profile-value">{{
                risk.recommended_products
              }}</span>
            </div> -->
            <div class="each-opportunity-product-details-section">
              <span class="client-profile-label">Reason:</span>
              <span class="client-profile-value">{{ risk.reason }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="each-opportunity-section" *ngIf="client_data.retention_opp.length == 0" style="width: 100%;">
        <div
          class="each-opportunity-zero-section"

        >
          <span>No Attrition Risk Found</span>
        </div>
      </div>
    </div>
    <!-- <div class="each-risk-section">
      <div class="each-opportunity-heading-section">
        <span>Attrition</span>
      </div>
      <div
        class="each-opportunity-content-section"
        *ngIf="client_data.Opportunities.attrition.length > 0"
      >
        <table class="risk-attrition-table">
          <thead>
            <tr>
              <th>Score</th>
              <th>Risk</th>
              <th>Reason</th>
              <th>Actual Loss({{APP_CONSTANTS.CURRENCY_SYMBOL}})</th>
              <th>Predicted overall loss({{APP_CONSTANTS.CURRENCY_SYMBOL}})</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let attrition of client_data.Opportunities.attrition">
              <td>{{ attrition.score }}</td>
              <td>{{ attrition.risk }}</td>
              <td>{{ attrition.reason }}</td>
              <td>{{ attrition.actual_loss }}</td>
              <td>{{ attrition.predicted_overall_loss }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="each-opportunity-zero-section"
        *ngIf="client_data.Opportunities.attrition.length == 0"
      >
        <span>No Attrition Risk Found</span>
      </div>
    </div> -->
  </div>
  <div *ngIf="selected_tab == 'Beneficiaries'">
    <div
      class="each-product-section"
      *ngFor="let beneficiary of client_data.beneficiaries"
    >
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">First Name</span>
          <span class="each-product-detail-value">{{
            beneficiary.first_name
          }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Last Name</span>
          <span class="each-product-detail-value">{{
            beneficiary.last_name
          }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Is Primary</span>
            <span class="each-product-detail-value">
              <span *ngIf="beneficiary.is_primary">Yes</span>
            <span *ngIf="!beneficiary.is_primary">No</span>
          </span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Email</span>
          <span class="each-product-detail-value">{{
            beneficiary.email
          }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Date of Birth</span>
          <span class="each-product-detail-value">{{
            beneficiary.birth_date | date: "MM-d-YYYY"
          }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Gender</span>
          <span class="each-product-detail-value">{{
            beneficiary.gender_name
          }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Relationship</span>
          <span class="each-product-detail-value">{{
            beneficiary.relationship_type_name
          }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Allocation (%)</span>
          <span class="each-product-detail-value">{{
            beneficiary.percentage_allocation
          }}</span>
        </div>
      </div>
    </div>
    <div
      class="each-opportunity-zero-section"
      *ngIf="client_data.beneficiaries.length == 0"
    >
      <span>No Beneficiaries Available</span>
    </div>
  </div>
  <div *ngIf="selected_tab == 'Client Goals'">
    <div
      class="each-product-section"
      *ngFor="let client_goal of client_data.client_goals"
    >
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Investment Purpose</span>
          <span class="each-product-detail-value">{{
            client_goal.investment_purpose
          }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Target Amount({{APP_CONSTANTS.CURRENCY_SYMBOL}})</span>
          <span class="each-product-detail-value">{{
            client_goal.target_amount
          }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Accomplished Target({{APP_CONSTANTS.CURRENCY_SYMBOL}})</span>
          <span class="each-product-detail-value">{{
            client_goal.accomplished_target
          }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Investment Goal Tenure</span>
          <span class="each-product-detail-value">{{
            client_goal.investment_goal_tenure
          }}</span>
        </div>
      </div>
      <div>
        <div class="each-product-detail-section">
          <span class="each-product-detail-label">Risk Tolerance</span>
          <span class="each-product-detail-value">{{
            client_goal.risk_tolerance
          }}</span>
        </div>
      </div>
    </div>
    <div
      class="each-opportunity-zero-section"
      *ngIf="client_data.client_goals.length == 0"
    >
      <!-- <span>No Client Goals Found</span> -->
      <span>No Goals Available</span>
    </div>
  </div>
</div>
